import { render, staticRenderFns } from "./checkNotice.vue?vue&type=template&id=7e36442c&scoped=true"
import script from "./checkNotice.vue?vue&type=script&lang=js"
export * from "./checkNotice.vue?vue&type=script&lang=js"
import style0 from "./checkNotice.vue?vue&type=style&index=0&id=7e36442c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e36442c",
  null
  
)

export default component.exports